module.exports = __webpack_public_path__ + "img/icon-prev-light.14e22733.svg";